import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-label__sheet" }

import { useTemplateRef } from 'vue'
import { platform } from '@/services/platform'

import InfoIcon from '@/app/components/InfoIcon.vue'
import BasePopup from '@/components/ui/BasePopup.vue'
import ContentLabelText from '@/app/components/doc/ContentLabelText.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentLabel',
  setup(__props) {

const popup = useTemplateRef('popup')

function openInfoSheet(): void {
  if (platform.isDesktopWidth()) {
    // We only show the info sheet on mobile. On desktop
    // we use `InfoIcon` to show the disclaimer text on hover.
    return
  }
  popup.value?.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "content-label",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (openInfoSheet()))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "content-label__text" }, "Generated with AI", -1)),
    _createVNode(InfoIcon, { class: "content-label__icon" }, {
      default: _withCtx(() => [
        _createVNode(ContentLabelText)
      ]),
      _: 1
    }),
    _createVNode(BasePopup, {
      ref_key: "popup",
      ref: popup
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, [
          _createVNode(ContentLabelText)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})